import { destroy, get, post, put } from './client';

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function getCustomers(data) {
    let dataToSend = 'customers';
    if (data.term === undefined || data.term === null ) {
        dataToSend = 'customers?current=' + data.current + '&pageSize=' + data.pageSize
    } else {
        if (data.current === undefined && data.pigeSize === undefined) {
            dataToSend = 'customers?term=' + data.term
        } else {
            dataToSend = 'customers?term=' + data.term + '&current=' + data.current + '&pageSize=' + data.pageSize;
        }
    }
    
    return get(dataToSend);
}

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function getOneCustomer(id) {
    return get('customer/' + id);
}

/**
 * 
 * @param {*} data 
 * @returns 
 */
export function postCustomer(data) {
    return post('customer', data);
}

/**
 * 
 * @param {*} id 
 * @param {*} data 
 * @returns 
 */
export function updateCustomer(data) {
    return put('customer', data);
}

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function deleteCustomer(id) {
    return destroy('customer/' + id);
}

/**
 *
 * @param {*} id
 */
export function archive(id) {
    return put('customer/' + id + '/archive');
}
